import { reactive } from "vue";

export const wishlistStore = reactive({
  count: 0,

  setCount(value) {
    this.count = value;
  },

  increment() {
    this.count++;
  },

  decrement() {
    if (this.count > 0) this.count--;
  },

  toggle(isAdded) {
    
    if (isAdded) this.increment();
    else this.decrement();
  },
});
